// extracted by mini-css-extract-plugin
module.exports = {"container":"CartWithoutProduct_container__2BvNM","directOrderContainer":"CartWithoutProduct_directOrderContainer__3u-KT"};